<template>
  <div class="date-range-picker" :class="{ 'date-range-picker--block': block }">
    <date-range-picker
      ref="picker"
      @update="handleDate"
      :locale-data="locale"
      :opens="opens"
      :append-to-body="appendToBody"
      v-model="dateRange"
      auto-apply
    >
      <template v-slot:input="picker">
        <div class="date-range-wrrapper">
          <span class="date" id="labelFor">
            {{ picker.startDate | date }} - {{ picker.endDate | date }}
          </span>
          <div class="calender" aria-hidden="true">
            <span
              class="calendar-icon mdi mdi-20px mdi-calendar-blank-outline"
            ></span>
          </div>
        </div>
      </template>
    </date-range-picker>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import { formatedDate } from "../utils/helpers";
export default {
  components: {
    DateRangePicker
  },
  props: {
    opens: {
      type: String,
      default: "left"
    },
    block: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateRange: {
        startDate: new Date(),
        endDate: new Date()
      },
      locale: {
        direction: "ltr",
        format: "YYYY-DD-MM",
        separator: " - ",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1,
        showWeekNumbers: true
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "This month": [moment().startOf("month"), moment().endOf("month")],
        "This year": [moment().startOf("year"), moment().endOf("year")],
        "Last week": [
          moment()
            .subtract(1, "week")
            .startOf("week"),
          moment()
            .subtract(1, "week")
            .endOf("week")
        ],
        "Last month": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ]
      }
    };
  },
  methods: {
    handleDate(val) {
      this.$emit("update", val);
    },
    handleReset() {
      this.dateRange.startDate = new Date();
      this.dateRange.endDate = new Date();
    }
  },
  filters: {
    date(val) {
      return val ? formatedDate(val) : "";
    }
  }
};
</script>

<style>
.date-range-picker {
  display: inline-block;
  max-width: 100%;
}

.date-range-picker .date {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 12px;
  font-style: normal;
  font-weight: normal;
  font-size: var(--fs-body);
  line-height: 1.25;
  letter-spacing: 0.04em;
  color: var(--text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendars {
  display: flex;
}

.daterangepicker .ranges li {
  font-style: normal;
  font-weight: 400;
  font-size: var(--fs-xs);
  line-height: 16px;
  color: var(--muted);
}

.daterangepicker .ranges li:focus {
  outline: none;
}

.daterangepicker td {
  font-weight: 400;
  font-size: var(--fs-xs);
  line-height: 16px;
  color: var(--text) !important;
}

.reportrange-text {
  border: none !important;
  width: auto !important;
  padding: 0 !important;
  background: transparent !important;
}

.calendar-icon {
  color: var(--muted-soft);
  line-height: 1;
}

.date-range-wrrapper {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--line);
  box-sizing: border-box;
  border-radius: var(--radius-md);
  background: var(--surface);
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}

.date-range-wrrapper:focus-within {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}

.daterangepicker {
  z-index: 10000001 !important;
  position: absolute !important;
  background: var(--surface) !important;
  border: 1px solid var(--line) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-md), 0 16px 40px rgba(26, 19, 54, 0.18) !important;
}

.daterangepicker .calendar-table {
  background: var(--surface) !important;
  border: none !important;
}

.daterangepicker .calendar-table th:focus {
  outline: none;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: var(--accent-600) !important;
  border-color: transparent !important;
  color: #fff !important;
  border-radius: var(--radius-sm) !important;
}

.daterangepicker td.in-range {
  background-color: var(--accent-050) !important;
  color: var(--text) !important;
}

.daterangepicker td:not(.off):not(.disabled):not(.active):hover {
  background-color: var(--accent-050) !important;
  border-radius: var(--radius-sm) !important;
}

.daterangepicker .ranges li.active {
  background-color: var(--accent-600) !important;
  border-radius: var(--radius-sm);
  color: #fff !important;
}

.daterangepicker .ranges li:hover {
  background-color: var(--accent-050) !important;
  border-radius: var(--radius-sm);
  color: var(--accent-600) !important;
}

.calender {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  margin-left: 4px;
  padding-left: 12px;
  border-left: 1px solid var(--line);
  box-sizing: border-box;
}

.daterangepicker .ranges li {
  font-style: normal;
  font-weight: 400;
  font-size: var(--fs-xs);
  line-height: 16px;
  color: var(--text);
}

.daterangepicker .calendar-table th {
  color: var(--muted);
  font-size: var(--fs-eyebrow);
  font-weight: 600;
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
}

/* Full-width variant for forms/modals */
.date-range-picker--block {
  display: block;
  width: 100%;
}

.date-range-picker--block .vue-daterange-picker,
.date-range-picker--block .reportrange-text,
.date-range-picker--block .date-range-wrrapper {
  display: block;
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
}

.date-range-picker--block .date-range-wrrapper {
  display: flex;
}
</style>
